/**
 * Products Hero – Matter.js Physics Shapes + Scroll More
 * Shapes fall from above with gravity, bounce, and collide
 * Uses Matter.js for physics, DOM elements for rendering
 */

(function () {
  'use strict';

  /* ---- Config ---- */
  var COLORS = ['#E37428', '#F9CE03', '#00A86B', '#1493B8', '#D3380D'];
  var SHAPE_TYPES = ['circle', 'half'];

  /* ---- Helpers ---- */
  function rand(min, max) { return Math.random() * (max - min) + min; }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  /* ---- Shape DOM element factory ---- */
  function createShapeEl(type, size, color, rotation) {
    var el = document.createElement('div');
    el.className = 'ph-shape ph-shape--' + type;
    el.style.cssText =
      'width:' + size + 'px;' +
      'height:' + size + 'px;' +
      'background-color:' + color + ';' +
      'position:absolute;' +
      'display:block;' +
      'opacity:0.95;' +
      'transform-origin:center center;';
    return el;
  }

  /* ---- Init physics for one section ---- */
  function initSection(heroEl) {
    var shapesLayer = heroEl.querySelector('.products-hero__shapes-layer');
    if (!shapesLayer) return;

    /* Clear existing shapes */
    shapesLayer.innerHTML = '';

    var Engine = Matter.Engine;
    var World = Matter.World;
    var Bodies = Matter.Bodies;
    var Runner = Matter.Runner;
    var Events = Matter.Events;

    var count = parseInt(shapesLayer.dataset.shapesCount, 10) || 30;
    var bounds = heroEl.getBoundingClientRect();
    var W = bounds.width;
    var H = bounds.height;

    /* Create engine */
    var engine = Engine.create({
      gravity: { x: 0, y: 0.6 }
    });

    /* Boundary: 70% centered on mobile, left-aligned 50% on desktop */
    var isMobile = window.innerWidth <= 749;
    var boundaryLeft = isMobile ? W * 0.15 : 0;
    var boundaryRight = isMobile ? W * 0.85 : W * 0.5;
    var boundaryCenter = (boundaryLeft + boundaryRight) / 2;
    var boundaryWidth = boundaryRight - boundaryLeft;

    /* Ground – invisible floor at section bottom */
    var ground = Bodies.rectangle(boundaryCenter, H + 25, boundaryWidth * 1.2, 50, { isStatic: true });

    /* Left wall */
    var wallLeft = Bodies.rectangle(boundaryLeft - 25, H / 2, 50, H + 100, { isStatic: true });

    /* Right wall */
    var wallRight = Bodies.rectangle(boundaryRight + 25, H / 2, 50, H + 100, { isStatic: true });

    World.add(engine.world, [ground, wallLeft, wallRight]);

    /* Create shapes */
    var shapes = [];
    for (var i = 0; i < count; i++) {
      var type = pick(SHAPE_TYPES);
      var vw = window.innerWidth;
      var size = vw <= 749 ? rand(26, 72) : vw <= 991 ? rand(40, 108) : rand(44, 120);
      var color = COLORS[i % COLORS.length];
      var rotation = Math.floor(rand(0, 4)) * 90;

      /* DOM element */
      var el = createShapeEl(type, size, color, rotation);
      /* Half-circle: height = half width for proper semicircle */
      var elHeight = (type === 'half') ? size / 2 : size;
      el.style.height = elHeight + 'px';
      shapesLayer.appendChild(el);

      /* Start position – within boundary, fall from above */
      var startX = rand(boundaryLeft + size, boundaryRight - size);
      var startY = rand(-800, -50);

      /* Physics body */
      var radius = size / 2;
      var body = Bodies.circle(startX, startY, radius, {
        restitution: 0.5,     /* bounciness */
        friction: 0.3,
        density: 0.002,
        frictionAir: 0.001
      });

      World.add(engine.world, body);

      shapes.push({
        el: el,
        body: body,
        size: size,
        rotation: rotation
      });
    }

    /* ---- Runner (start paused – shapes fall only after hero is scrolled to top) ---- */
    var runner = Runner.create();
    runner.enabled = false;
    Runner.run(runner, engine);

    var shapesStarted = false;

    function checkShapesStart() {
      if (shapesStarted) return;
      var rect = heroEl.getBoundingClientRect();
      /* Start when the hero's top edge reaches the viewport top */
      if (rect.top <= 0) {
        shapesStarted = true;
        runner.enabled = true;
        window.removeEventListener('scroll', checkShapesStart);
      }
    }
    window.addEventListener('scroll', checkShapesStart, { passive: true });

    /* ---- Sync DOM to physics on each frame ---- */
    function syncDOM() {
      for (var i = 0; i < shapes.length; i++) {
        var s = shapes[i];
        var pos = s.body.position;
        var angle = s.body.angle;

        s.el.style.transform = 'translate(' + (pos.x - s.size / 2) + 'px, ' + (pos.y - s.size / 2) + 'px) rotate(' + (angle * 180 / Math.PI + s.rotation) + 'deg)';
      }
      requestAnimationFrame(syncDOM);
    }
    requestAnimationFrame(syncDOM);

    /* ---- Mouse interaction – push shapes away ---- */
    var Mouse = Matter.Mouse;
    var MouseConstraint = Matter.MouseConstraint;

    var mouse = Mouse.create(shapesLayer);
    /* Fix for hi-DPI screens */
    mouse.pixelRatio = window.devicePixelRatio || 1;

    var mouseConstraint = MouseConstraint.create(engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false }
      }
    });

    World.add(engine.world, mouseConstraint);

    /* ---- Resize handler ---- */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newBounds = heroEl.getBoundingClientRect();
        var newW = newBounds.width;
        var newH = newBounds.height;

        /* Update walls and ground */
        Matter.Body.setPosition(ground, { x: newW * 0.25, y: newH + 25 });
        Matter.Body.setPosition(wallRight, { x: newW * 0.5 + 25, y: newH / 2 });
        Matter.Body.setPosition(wallLeft, { x: -25, y: newH / 2 });
      }, 200);
    });
  }


  /* ---- Bootstrap (wait for Matter.js) ---- */
  function init() {
    document.querySelectorAll('.products-hero').forEach(function (heroEl) {
      initSection(heroEl);
    });
  }

  function waitForMatter() {
    if (typeof Matter !== 'undefined' && Matter.Engine) {
      init();
    } else {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (typeof Matter !== 'undefined' && Matter.Engine) {
          clearInterval(interval);
          init();
        } else if (attempts > 100) {
          clearInterval(interval);
          console.warn('[Products Hero] Matter.js not loaded, shapes disabled');
          document.querySelectorAll('.products-hero').forEach(function (heroEl) {
          });
        }
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForMatter);
  } else {
    waitForMatter();
  }

  /* ---- Theme editor support ---- */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.products-hero');
      if (section) {
        waitForMatter();
      }
    });
  }
})();
